module.exports = __webpack_public_path__ + "static/img/The Last Judgment.f7fb842.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/The Last Judgment.jpg
// module id = 1317
// module chunks = 0